import React from 'react';
import useWindowSizes from 'shared/hooks/useWindowSizes';
import { getZoom } from 'shared/utils/appHelpers';
import { LogoMediumIcon } from '../Icons';

const AlertTemplate = ({ message, options, style, close }) => {
  const [width] = useWindowSizes();

  return (
    <div style={{ ...style, zoom: getZoom(width) }} className='alert-template p-15 p-md-25'>
      {/* {options.type === 'info' && <InfoIcon />}
      {options.type === 'success' && <SuccessIcon />}
      {options.type === 'error' && <ErrorIcon />} */}
      <LogoMediumIcon />
      <span style={{ flex: 2 }} className='ml-5'>
        {message}
      </span>
      {/* <button onClick={close}>close</button> */}
    </div>
  );
};

export default AlertTemplate;
